/// <reference types="@angular/localize" />

import {AppModule} from "./app/app.module";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import '@angular/localize/init';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
